export default "__VITE_ASSET__D7Shoah6__"